import React from 'react';
import { usePermissions } from '../../utils/usePermissions';
import NotFound from './NotFound';
import Loader from './Loader';

/**
 * ProtectedPage Component
 * Wraps page components to enforce permission-based access
 * 
 * Usage:
 * <ProtectedPage module="revenue" fallback={<AccessDenied />}>
 *   <YourPageContent />
 * </ProtectedPage>
 */
function ProtectedPage({ module, children, fallback = null }) {
  const { canViewModule, user } = usePermissions();

  // If user data not loaded yet, show loading
  if (!user) {
    return (
      <div style={{ padding: '60px 20px', display: 'flex', justifyContent: 'center' }}>
        <Loader size="large" label="Loading..." />
      </div>
    );
  }

  // Check if user has permission to view this module
  const hasAccess = canViewModule(module);

  if (!hasAccess) {
    if (fallback) {
      return fallback;
    }

    // Default access denied UI
    return (
      <div style={{
        padding: '40px 20px',
        textAlign: 'center',
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: '#dc2626' }}>
          Access Denied
        </div>
        <div style={{ fontSize: '16px', color: '#64748b', marginBottom: '20px' }}>
          You don't have permission to access this module.
        </div>
        <div style={{ fontSize: '14px', color: '#94a3b8' }}>
          Please contact your administrator if you believe this is a mistake.
        </div>
        <div style={{
          marginTop: '20px',
          padding: '12px 24px',
          backgroundColor: '#3b82f6',
          color: 'white',
          borderRadius: '6px',
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'inline-block'
        }}
          onClick={() => window.history.back()}
        >
          Go Back
        </div>
      </div>
    );
  }

  return children;
}

export default ProtectedPage;
